import { Injectable } from "@angular/core";
import { BaseService } from "../../@core/services/base.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment.dev";
import { Observable } from "rxjs";
import { CONNECTOR_PROVIDERS, TOOLKIT_PROVIDERS } from "src/app/features/general-agent/constants/tool.constants";

export interface ListFilesParams {
    connector: string;
    folderId?: string;
    folderPath?: string;
    serverRelativeUrl?: string;
    siteUrl?: string;
    page?: number;
    pageSize?: number;
    pageToken?: string;
    cursor?: string;
}

export interface ListFilesResponse {
    success: boolean;
    data?: unknown;
    nextPageToken?: string;
    nextCursor?: string;
    hasMore?: boolean;
}

export interface DownloadFileParams {
    connector: string;
    fileId?: string;
    path?: string;
    serverRelativeUrl?: string;
    file_name?: string;
    mime_type?: string;
}

export interface DownloadFileResponse {
    success: boolean;
    data?: unknown;
}

export interface ListMailsParams {
    connector: string;
    folderId?: string;
    pageSize?: number;
    pageToken?: string;
}

export interface MailAttachmentInfo {
    id: string;
    name?: string;
    contentType?: string;
    size?: number;
    isInline?: boolean;
}

export interface MailMessageInfo {
    id: string;
    subject?: string;
    from?: { name?: string; address?: string };
    receivedDateTime?: string;
    hasAttachments?: boolean;
    attachments?: MailAttachmentInfo[];
}

export interface DownloadMailAttachmentParams {
    connector: string;
    messageId: string;
    attachmentId: string;
    filename?: string;
    mimeType?: string;
}

@Injectable({ providedIn: 'root' })
export class IntegrationsService extends BaseService {

    apiUrl = environment.apiUrl + '/integrations';

    constructor(protected override http: HttpClient) {
        super(http);
    }

    getAllIntegrations() {
        return this.get<{ integrations: any[] }>(this.apiUrl);
    }

    disconnectIntegration({ key, value }: { key: string, value: string }) {
        return this.post<{ success: boolean }>(this.apiUrl + '/disconnect', { key, value });
    }

    listFiles(params: ListFilesParams): Observable<{ success: boolean; data?: unknown; nextPageToken?: string; nextCursor?: string; hasMore?: boolean }> {
        return this.post<ListFilesResponse>(this.apiUrl + '/list-files', params);
    }

    downloadFile(params: DownloadFileParams): Observable<DownloadFileResponse> {
        return this.post<DownloadFileResponse>(this.apiUrl + '/download-file', params);
    }

    listMails(params: ListMailsParams): Observable<{ success: boolean; data?: { data?: MailMessageInfo[]; nextPageToken?: string; hasMore?: boolean } }> {
        return this.post(this.apiUrl + '/list-mails', params);
    }

    downloadMailAttachment(params: DownloadMailAttachmentParams): Observable<{ success: boolean; data?: { url: string; filename: string; type: string } }> {
        return this.post(this.apiUrl + '/download-mail-attachment', params);
    }

    addDatabaseConnection(data: { provider: string, connectionUrl: string, host: string, port: string, database: string, username: string, password: string, save?: boolean }) {
        return this.post<{ success: boolean }>(this.apiUrl + '/add-database-connection', data);
    }

    disconnectDatabaseConnection({ provider }: { provider: string }) {
        return this.post<{ success: boolean }>(this.apiUrl + '/disconnect-database-connection', { provider });
    }

    addConnector(data: { toolKit: TOOLKIT_PROVIDERS, connectedAccountId?: string, appName?: string, status?: string, callbackUrl?: string }) {
        return this.post<{ redirectUrl: string, status: boolean }>(this.apiUrl + `/add-connector`, data);
    }

    disableConnector(toolKit: CONNECTOR_PROVIDERS) {
        return this.post<{ status: boolean }>(this.apiUrl + `/disable-connector`, { toolKit });
    }

    enableConnector(toolKit: CONNECTOR_PROVIDERS) {
        return this.post<{ status: boolean }>(this.apiUrl + `/enable-connector`, { toolKit });
    }

    getConnectors() {
        return this.get<any>(this.apiUrl + `/connectors`);
    }

}
